import React from "react";
import styles from "./typography.css";
import * as classNames from "classnames";

export const Title = ({ children, className }) => {
	const allClassNames = classNames(styles.title, className);

	return <h1 className={allClassNames}>{children}</h1>;
};

export const Heading = ({ children, className }) => {
	const allClassNames = classNames(styles.heading, className);

	return <h2 className={allClassNames}>{children}</h2>;
};

export const Subheading = ({ children, className }) => {
	const allClassNames = classNames(styles.subheading, className);

	return <h3 className={allClassNames}>{children}</h3>;
};

export const Paragraph = ({ children, className }) => {
	const allClassNames = classNames(styles.paragraph, className);

	return <p className={allClassNames}>{children}</p>;
};

export const SmallParagraph = ({ children, className }) => {
	const allClassNames = classNames(styles.smallParagraph, className);

	return <p className={allClassNames}>{children}</p>;
};



// WEBPACK FOOTER //
// ./src/components/ui/typography/typography.js